var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-question-wrap" }, [
    _c(
      "div",
      { staticClass: "subject" },
      [
        !_vm.isHideName
          ? _c("div", { staticClass: "stem" }, [
              _c("div", { staticClass: "nameText" }, [
                _vm.$route.path === "/practiceAnalysis"
                  ? _c(
                      "em",
                      { class: `${_vm.toggleClass(_vm.datas.is_make)}` },
                      [_vm._v(_vm._s(_vm.datas.sort))]
                    )
                  : _c("em", [_vm._v(_vm._s(_vm.datas.sort))]),
                _c("p", { staticStyle: { flex: "1" } }, [
                  _c("span", [
                    _vm._v("[" + _vm._s(_vm.datas.question_title) + "]"),
                  ]),
                  _c("i", { staticClass: "mal10" }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#343434 !important",
                          "white-space": "pre-wrap",
                        },
                      },
                      [_vm._v(_vm._s(_vm.datas.title))]
                    ),
                    _vm._v(" (本题" + _vm._s(_vm.datas.fraction) + "分) "),
                  ]),
                  _vm.datas.title_thumb
                    ? _c("i", [_vm._v("(点击图片放大)")])
                    : _vm._e(),
                ]),
              ]),
              _vm.isAnalysis
                ? _c(
                    "div",
                    {
                      staticClass: "operation",
                      on: { click: _vm.showAnalysis },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "uni-cursor",
                          class: { active: _vm.isAnalysis },
                        },
                        [
                          _c("i", { staticClass: "iconfont iconhuabanfuben" }),
                          _c("span", [_vm._v("查看解析")]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm.datas.audio_url
          ? _c(
              "div",
              { staticClass: "audioDiv" },
              _vm._l(
                _vm.datas.audio_url.split(","),
                function (itemAudio, indexAudio) {
                  return _c(
                    "audio",
                    {
                      key: indexAudio,
                      staticClass: "sourceAudio",
                      attrs: { controls: "controls" },
                    },
                    [
                      _c("source", {
                        attrs: { src: itemAudio, type: "audio/ogg" },
                      }),
                      _vm._v(
                        " Your browser does not support the audio element. "
                      ),
                    ]
                  )
                }
              ),
              0
            )
          : _vm._e(),
        _vm.datas.title_thumb
          ? _c("el-image", {
              staticClass: "mat20 mal20",
              staticStyle: { "max-width": "200px", color: "#fff" },
              attrs: {
                fit: "contain",
                src: _vm.datas.title_thumb,
                "preview-src-list": [_vm.datas.title_thumb],
              },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "radio-group" },
          [
            _c(
              "el-checkbox-group",
              {
                attrs: { disabled: _vm.isDisabled },
                on: { change: _vm.theRadio },
                model: {
                  value: _vm.answer,
                  callback: function ($$v) {
                    _vm.answer = $$v
                  },
                  expression: "answer",
                },
              },
              _vm._l(_vm.datas.item, function (item, index) {
                return _c(
                  "el-checkbox",
                  {
                    key: index,
                    staticClass: "answer",
                    attrs: {
                      label: JSON.stringify({
                        option: item.option,
                        key: item.key,
                      }),
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "topic-content" },
                      [
                        _c("span", { staticClass: "span" }, [
                          _vm._v(" " + _vm._s(item.option) + "."),
                        ]),
                        item.img === ""
                          ? _c("span", [_vm._v(_vm._s(item.value))])
                          : _vm._e(),
                        item.img
                          ? _c("el-image", {
                              staticClass: "mal10",
                              staticStyle: {
                                width: "50px",
                                height: "50px",
                                color: "#fff",
                              },
                              attrs: {
                                fit: "contain",
                                src: item.img,
                                "preview-src-list": [item.img],
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }